import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
@Directive({
  selector: '[appNoWhiteSpc]',
  standalone: false,
})
export class NoWhiteSpcDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const trimmedValue = input.value.replace(/^\s+/, '');

    if (input.value !== trimmedValue) {
      this.ngControl.control?.setValue(trimmedValue, { emitEvent: false });
    }
  }
}
